module.exports = __webpack_public_path__ + "img/g4.de76a1bb.png";